import { PACKAGE_TYPES } from "@alpitour/resources";
import { markup } from "@alpitour/utilities";

export default {
  methods: {
    markup(price) {
      let calculate_display_price = true;
      try {
        // Do not calculate display price for sololand flow as prices change less
        const { package_type } = this.$store.state.liveat;
        calculate_display_price = package_type !== PACKAGE_TYPES.ONLY_STAY;
      } catch {
        // EMPTY: Apply mark up as you usually would
      }
      return markup(price, calculate_display_price);
    },
  },
};
